/**
 * TRS-03 — which FICA review date the statutory calendar may clock.
 *
 * A trust with NO initial FICA on file has no review CYCLE yet: the "next
 * review" date on the trust doc is a periodic-cycle artefact and listing it
 * tells the client a biennial clock is running on a file that has never been
 * verified once. So while FICA is known-and-absent, the calendar gets nothing.
 * While FICA state is still loading (`ficaKnown` false) we fall back to the
 * trust's own date rather than blanking the calendar on every render.
 *
 * PURE and exported so it is unit-tested without mounting the overview.
 */
export function calendarFicaReviewOn(input: {
  ficaKnown: boolean;
  noInitialFica: boolean;
  nextFicaReview: string | null | undefined;
}): string | null | undefined {
  if (input.ficaKnown && input.noInitialFica) return undefined;
  return input.nextFicaReview;
}
